"use strict";

exports.__esModule = true;
exports.onRouteUpdate = void 0;
var onRouteUpdate = exports.onRouteUpdate = function onRouteUpdate() {
  if (window.posthog) {
    window.posthog.capture('$pageview');
  }
};